import * as Widgets from '@/services/bb_widgets';
import { get } from 'lodash';
import { getDataWithoutProperties } from '@/services/utils';

const state = {
  all: [],
  isLoading: false
};

const getters = {
  all: state => state.all,

  hasManuallyPublishedArticles: state => {
    let result = false;

    state.all.forEach(widget => {
      const auto_publication = get(widget, 'auto_publication', true);
      if (auto_publication === false) {
        result = true;
      }
    });

    return result;
  },

  isLoading: state => state.isLoading
};

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },

  SET_WIDGET(state, payload) {
    const index = state.all.findIndex(item => {
      return item.id === payload.id;
    });

    /**
     * Handle properties with relation to other DBs
     * Remove properties that are no arrays or objects
     */
    const relationalProps = ['articles', 'company', 'tags'];
    const data = getDataWithoutProperties(payload, relationalProps);

    // Update or push item
    if (index !== -1) {
      const items = state.all.slice();
      items.splice(index, 1, data);
      state.all = items;
    } else {
      state.all.push(data);
    }
  },

  SET_WIDGETS(state, payload) {
    state.all = payload;
  }
};

const actions = {
  async GET_WIDGET_BY_ID({ commit }, payload) {
    const { id } = payload;

    try {
      commit('SET_LOADING', true);
      const response = await Widgets.getWidget(id);
      const data = get(response, 'data', []);
      if (data && data.length) {
        commit('SET_WIDGET', data[0]);
      }
      commit('SET_LOADING', false);
      return data;
    } catch (error) {
      throw new Error(error);
    }
  },

  async GET_WIDGETS_FOR_COMPANY({ commit }, payload) {
    const { id } = payload;
    try {
      commit('SET_LOADING', true);
      const response = await Widgets.getWidgetsByCompany(id);
      const data = get(response, 'data', []);
      commit('SET_WIDGETS', data);
      commit('SET_LOADING', false);
    } catch (error) {
      throw new Error(error);
    }
  },

  async SAVE_WIDGET({ commit }, payload) {
    try {
      commit('SET_LOADING', true);
      const response = await Widgets.saveWidget(payload);
      // commit('SET_WIDGET', response.data);
      commit('SET_LOADING', false);
      return response;
    } catch (error) {
      throw new Error(error);
    }
  },

  async UPDATE_WIDGET({ commit }, payload) {
    try {
      commit('SET_LOADING', true);
      const response = await Widgets.updateWidget(payload.id, payload);
      commit('SET_LOADING', false);
      const data = get(response, 'data');
      // const forceUpdate = get(payload, 'forceUpdate', false);
      if (data) {
        commit('SET_WIDGET', data);
      }

      return response;
    } catch (error) {
      commit('SET_LOADING', false);
      throw new Error(error);
    }
  }
};

export const MODULE_NAME = 'bb_widgets';

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
